import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import mdLogo from '../assets/mdlogo.png';

const features = [
  'Expert billing for small practices',
  'AI-powered claim accuracy',
  'Seamless EMR integration',
  'Real-time denial alerts',
  'Optimized collections'
];

const AdvantageSection = () => {
  const [visibleCount, setVisibleCount] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('advantage-section');
      if (!section || hasAnimated) return;
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.8) {
        setHasAnimated(true);
        let counter = 0;
        const interval = setInterval(() => {
          counter++;
          setVisibleCount(counter);
          if (counter >= features.length) clearInterval(interval);
        }, 400);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasAnimated]);

  return (
    <section
      id="advantage-section"
      style={{
        width: '100%',
        maxWidth: '100vw',
        overflowX: 'hidden',
        background: 'linear-gradient(to bottom, #000, #0a0a0a)',
        color: '#ffffff',
        padding: '100px 5%',
        fontFamily: 'Poppins, sans-serif',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'flex-start',
        textAlign: 'left',
        gap: '20px',
        boxSizing: 'border-box',
      }}
    >
  
      {/* Column 1: Heading + Intro - SEO OPTIMIZED with NEW KEYWORDS */}
      <div
        style={{
          flex: '0 0 33.33%',
          maxWidth: '33.33%',
          minWidth: '280px',
          animation: 'fadeInLeft 1s ease-out',
        }}
      >
        {/* H2 with Keywords */}
        <h2 style={{ 
          fontSize: '2.5rem', 
          fontWeight: '700', 
          marginBottom: '20px',
          lineHeight: '1.2'
        }}>
          The MDeRCM <br /> Advantage
        </h2>
        
        {/* H3 supporting heading with NEW KEYWORDS */}
        <h3 style={{ 
          fontWeight: 600, 
          fontSize: '1.2rem', 
          marginBottom: '15px',
          color: '#00ffff'
        }}>
          Medical Billing Outsourcing for Small Practices Made Simple
        </h3>
        
        <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#e0e0e0', marginBottom: '20px' }}>
          Drive efficiency and reduce costs with our specialized{' '}
          <Link 
            to="/medical-billing-outsourcing-small-practices"
            style={{ color: '#00ffff', textDecoration: 'underline' }}
          >
            medical billing outsourcing for small practices
          </Link>, designed for independent physicians and multispecialty clinics.
        </p>
        
        <p style={{ fontSize: '1rem', lineHeight: '1.8', color: '#ccc' }}>
          MDeRCM is purpose-built for small practices needing comprehensive{' '}
          <Link 
            to="/revenue-cycle-management-independent-physicians"
            style={{ color: '#00ffff', textDecoration: 'underline' }}
          >
            revenue cycle management
          </Link>. Our AI Agents integrate seamlessly to automate claims, provide{' '}
          <Link 
            to="/denial-management-services-medical-clinics"
            style={{ color: '#00ffff', textDecoration: 'underline' }}
          >
            denial management services
          </Link>, and give you full visibility. Scalable. Compliant. Cost-effective.
        </p>
      </div>

      {/* Column 2: Pain Points & Solutions - SEO OPTIMIZED */}
      <div
        style={{
          flex: '0 0 30%',
          maxWidth: '33.33%',
          minWidth: '280px',
          animation: 'fadeIn 1.4s ease-out',
        }}
      >
        <h4 style={{ 
          color: '#00ffff', 
          fontSize: '1.2rem', 
          marginBottom: '15px',
          fontWeight: '600'
        }}>
          Common Challenges for Small Practices
        </h4>
        <ul style={{ 
          color: '#ccc', 
          fontSize: '1rem', 
          lineHeight: '1.8', 
          paddingLeft: '20px', 
          marginBottom: '30px',
          listStyleType: 'disc'
        }}>
          <li>High claim denial rates (15-20%)</li>
          <li>Limited billing staff and expertise</li>
          <li>No real-time revenue visibility</li>
          <li>Complex multispecialty billing needs</li>
          <li>Manual processes causing delays</li>
        </ul>

        <h4 style={{ 
          color: '#00ffff', 
          fontSize: '1.2rem', 
          marginBottom: '15px',
          fontWeight: '600'
        }}>
          How Our Solutions Help
        </h4>
        <ul style={{ 
          color: '#ccc', 
          fontSize: '1rem', 
          lineHeight: '1.8', 
          paddingLeft: '20px',
          listStyleType: 'disc'
        }}>
          <li>
            <Link 
              to="/reduce-claim-denials-healthcare-billing"
              style={{ color: '#00ffff', textDecoration: 'underline' }}
            >
              Reduce claim denials
            </Link>{' '}
            by 35-45%
          </li>
          <li>Expert billing support for independent physicians</li>
          <li>Live dashboards with revenue tracking</li>
          <li>
            <Link 
              to="/revenue-cycle-management-multispecialty-practices"
              style={{ color: '#00ffff', textDecoration: 'underline' }}
            >
              Multispecialty RCM
            </Link>{' '}
            expertise
          </li>
          <li>Automated workflow processing</li>
        </ul>

        <div style={{
          marginTop: '25px',
          padding: '15px',
          backgroundColor: 'rgba(0, 119, 182, 0.1)',
          borderRadius: '8px',
          border: '1px solid rgba(0, 191, 255, 0.3)'
        }}>
          <p style={{
            fontSize: '0.95rem',
            lineHeight: '1.7',
            color: '#e0e0e0',
            margin: 0
          }}>
            <strong style={{ color: '#00ffff' }}>Experience all benefits:</strong>{' '}
            <Link 
              to="/benefits-medical-billing-outsourcing-clinics"
              style={{ color: '#00ffff', textDecoration: 'underline' }}
            >
              medical billing outsourcing for clinics
            </Link>{' '}
            with proven ROI for small practices.
          </p>
        </div>
      </div>

      {/* Column 3: Circle Features */}
      <div
        style={{
          position: 'relative',
          maxWidth: '33.33%',
          minWidth: '400px',
          height: '500px',
          animation: 'fadeInUp 1.2s ease-out',
          marginLeft: '60px',
        }}
      >
        <img
          src={mdLogo}
          alt="MDeRCM Medical Billing Outsourcing for Small Practices Logo"
          style={{
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            objectFit: 'contain',
            boxShadow: '0 0 60px #00ffff',
            position: 'absolute',
            top: '50%',
            left: '0%',
            transform: 'translate(-50%, -50%)',
            zIndex: 2,
            animation: 'pulseGlow 3s infinite ease-in-out',
          }}
        />

        {features.slice(0, visibleCount).map((f, i) => {
          const angle = (180 / (features.length - 1)) * i - 90;
          const radius = 180;
          const x = radius * Math.cos((angle * Math.PI) / 180);
          const y = radius * Math.sin((angle * Math.PI) / 180);

          return (
            <div
              key={i}
              style={{
                position: 'absolute',
                top: `calc(50% + ${y}px)`,
                left: `calc(0% + ${x}px)`,
                transform: 'translate(-50%, -50%)',
                background: '#fff',
                color: '#0077b6',
                padding: '10px',
                borderRadius: '50%',
                boxShadow: '0 0 20px rgba(0, 255, 255, 0.4)',
                width: '100px',
                height: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                fontWeight: 500,
                fontSize: '0.75rem',
                zIndex: 1,
              }}
            >
              {f}
            </div>
          );
        })}
      </div>

      {/* Animations and Responsive */}
      <style>{`
        @keyframes pulseGlow {
          0%, 100% {
            box-shadow: 0 0 60px #00ffff;
          }
          50% {
            box-shadow: 0 0 90px #00ffff;
          }
        }

        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @media (max-width: 768px) {
          #advantage-section {
            display: none !important;
          }
        }

        @media (max-width: 1024px) {
          div[style*="flex: '0 0 33.33%'"] {
            max-width: 100% !important;
            flex: 0 0 100% !important;
          }

          section {
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding: 60px 5%;
          }

          div[style*='height: 500px'] {
            height: 400px !important;
            margin-top: 40px;
          }

          div[style*='width: 200px'] {
            width: 160px !important;
            height: 160px !important;
          }

          ul {
            text-align: left;
            list-style-position: inside;
          }
        }
      `}</style>
    </section>
  );
};

export default AdvantageSection;